const authorities = Object.freeze({
  ADMIN: 'ROLE_ADMIN',
  BASE: 'ROLE_Base',
  HR: 'ROLE_HR'
});

export { authorities };
